import Image from "next/image";
import CurrencyConverter from "@/components/CustomUI/modules/CurrencyConverter";
import { getEstimatedDate } from "@/lib/utils";


const MainDetails = ({ data }) => {
    const fixedPrice = data.variant_price.toFixed();
    const fixedMrp = data.variant_mrp.toFixed();
    let category = null;
    if (data.product && data.product.category && data.product.category.name) {
        if (data.product.category.name.endsWith("s")) category = data.product.category.name.slice(0, -1);
    }

    return (
        <div className="w-full flex gap-x-2 text-base">
            <div className="md:w-[50%] lg:w-[35%] desktop:w-auto p-2">
                <Image
                    unoptimized
                    src={data.product.image.url}
                    alt={data.product.image.alt || "ORNAZ"}
                    width={170}
                    height={170}
                    className="rounded"
                />
            </div>
            <div className="flex-1 space-y-1 lg:space-y-2 pt-2">
                <h2 className="font-semibold">{data.product.name}</h2>

                <div className="flex items-center gap-x-3">
                    <span className="font-semibold">
                        <CurrencyConverter amount={fixedPrice} />
                    </span>
                    
                    {fixedPrice !== fixedMrp &&
                        <span className="line-through text-sm font-medium">
                            <CurrencyConverter amount={fixedMrp} />
                        </span>
                    }
                </div>

                <p className="text-sm md:text-xs md:tracking-tighter lg:tracking-normal lg:ml-0 lg:text-sm text-[#007500]">
                    (Est. Delivery{" "}
                    {data.estimated_delivery_days === 0
                        ? "Today"
                        : data.estimated_delivery_days === 1
                            ? "Tommorrow"
                            : getEstimatedDate(data.estimated_delivery_days)}
                    )
                </p>

                <div className="inline-flex rounded-sm border border-slate-300 px-2 lg:py-1 bg-white md:w-full lg:w-fit text-center">
                    {data.size != undefined && data.size != 1 ?
                        <p className="text-sm md:text-xs font-medium w-full">{category} Size - {data.size}</p> :
                        <p className="text-sm md:text-xs font-medium w-full">{category + " Sizer on the way"}</p>
                    }
                </div>

                <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-sm md:text-xs lg:text-sm font-medium">
                    {!data.total_diamond_weight === false &&
                        <div className="rounded-sm border border-slate-300 px-2 lg:py-1 bg-white md:w-full lg:w-fit text-center">
                            <span>
                                {data.total_diamond_weight.toFixed(3)} ct ({data.diamond_clarity}-{data.diamond_color})
                            </span>
                        </div>
                    }
                    {!data.metal_weight === false &&
                        <div className="rounded-sm border border-slate-300 px-2 lg:py-1 bg-white md:w-full lg:w-fit text-center">
                            <span>
                                {data.metal_weight.toFixed(3)} gm ({data.metal_carat} KT)
                            </span>
                        </div>
                    }
                </div>

            </div>
        </div>
    )
}

export default MainDetails